module.exports = __webpack_public_path__ + "assets/img/avatar_bg.53545de8.png";